<template>
  <div class="status-root">
    <v-card outlined elevation="0" class="rounded-lg status-card">
      <div class="d-flex align-center px-3 py-2">
        <v-icon color="primary" small class="mr-2">mdi-flag-outline</v-icon>
        <span class="text-subtitle-2 font-weight-bold primary--text"
          >Assessment Status</span
        >
      </div>
      <v-divider />
      <div class="px-3 py-3">
        <p class="text-caption status-hint mb-2">
          Select an outcome for this vehicle. This action cannot be undone.
        </p>
        <v-chip-group v-model="assessmentStatus" column @change="showModal">
          <v-chip
            v-for="(status, index) in statuses"
            :key="index"
            :value="status.value"
            outlined
            class="status-chip"
            active-class="status-chip--active"
          >
            <v-icon left small>{{ statusIcon(status.value) }}</v-icon>
            {{ status.name }}
          </v-chip>
        </v-chip-group>
      </div>
    </v-card>
    <div class="add--vehicle tw-mb-6">
      <v-dialog v-model="showAssessmentStatusDialog" width="400px">
        <v-card class="dlg-card">
          <dialog-header
            :title="`Confirm ${selectedAssessmentStatusName || ''} selection`"
            icon="mdi-check-circle-outline"
            @close="closeModal"
          />
          <v-divider></v-divider>
          <v-container class="text-center">
            <v-card-text class="dlg-body">
              <p>
                You will not be able to recover this
                <br />
                decision, are you sure you want to select
                <br />
                this vehicle as a {{ selectedAssessmentStatusName }} ?
              </p>
            </v-card-text>
            <v-card-actions class="dlg-actions">
              <div class="ma-auto pb-2">
                <v-row align="center" justify="space-around">
                  <v-btn outlined @click="closeModal" color="primary"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="primary"
                    class="ma-5 pa-4"
                    @click="updateAssessmentStatus"
                    :loading="loading"
                  >
                    Yes
                  </v-btn>
                </v-row>
              </div>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import DialogHeader from '@/components/DialogHeader'

export default {
  name: 'AssessmentStatusCheckbox',
  components: { DialogHeader },
  props: {
    bookingId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      assessmentStatus: null,
      loading: false,
      showAssessmentStatusDialog: false,
      statuses: [],
    }
  },
  mounted() {
    this.getStatuses()
  },
  computed: {
    selectedAssessmentStatusName: function () {
      return this.assessmentStatus
        ? this.assessmentStatus.replaceAll('_', ' ').toUpperCase()
        : null
    },
  },
  methods: {
    showModal: function () {
      this.showAssessmentStatusDialog = true
    },
    updateAssessmentStatus() {
      axios
        .patch(
          `/motor-assessment/api/internal-assessor/update-booking-status/${this.bookingId}/${this.assessmentStatus}`
        )
        .then((response) => {
          if (response.data.success) {
            this.$store.commit('SNACKBAR', {
              state: 'success',
              message: `Vehicle selected as a ${this.selectedAssessmentStatusName}`,
              variant: 'success',
            })

            this.$router.push({ name: 'BidsSubmitted' })
          } else {
            this.$store.commit('SNACKBAR', {
              state: 'failed',
              message: response.data.msg,
              variant: 'error',
            })
          }
          this.loading = false
        })
        .catch(() => {
          this.$toasted.error('An error occurred, try again', {
            duration: 3000,
          })
        })
    },
    getStatuses() {
      axios.get('/motor-assessment/api/bid/status').then((res) => {
        // Safely check if response and data exist
        if (!res || !res.data || !res.data.data) {
          this.statuses = []
          this.loading = false
          return
        }

        this.statuses = res.data.data.map((status) => ({
          name: this.getStatusName(status),
          value: status,
        }))
        this.loading = false
      })
    },
    getStatusName(status) {
      switch (status) {
        case 'CASH_IN_LIEU':
          return 'Cash in Lieu'
        case 'BELOW_EXCESS':
          return 'Below Excess'
        case 'WRITE_OFF':
          return 'Write Off'
        case 'UNDOCUMENTED':
          return 'Undocumented'
        case 'DECLINED':
          return 'Declined'
        case 'UNDER_INVESTIGATIONS':
          return 'Under Investigations'
        default:
          return status
      }
    },
    statusIcon(status) {
      switch (status) {
        case 'CASH_IN_LIEU':
          return 'mdi-cash'
        case 'BELOW_EXCESS':
          return 'mdi-cash-minus'
        case 'WRITE_OFF':
          return 'mdi-car-off'
        case 'UNDOCUMENTED':
          return 'mdi-file-document-alert-outline'
        case 'DECLINED':
          return 'mdi-close-circle-outline'
        case 'UNDER_INVESTIGATIONS':
          return 'mdi-magnify'
        default:
          return 'mdi-flag-outline'
      }
    },
    closeModal: function () {
      this.showAssessmentStatusDialog = false
      this.assessmentStatus = null
    },
  },
}
</script>

<style scoped>
.status-root {
  height: 100%;
}
.status-card {
  border-color: #e3e8ef;
  background: #fbfcfe;
  height: 100%;
}
.status-hint {
  color: #475467;
}
.status-chip {
  font-weight: 600;
}
.status-chip--active {
  background: #034ea2 !important;
  color: #ffffff !important;
  border-color: #034ea2 !important;
}
</style>
